<template>

  <div>
    <Sidebar 
      v-if="pageOptions.pageWithSidebar"
      :user="user"
      :checkRole="checkRole"
      class="d-none d-lg-block"
    />
    <Sidebar 
      v-if="pageOptions.pageWithMobileSidebar"
      :user="user"
      :checkRole="checkRole"
      class="d-lg-none"
    />
    <Header />
    <b-container fluid class="mt-5">
      <b-row>
        <b-col cols="0" class="d-none d-lg-block" :style="{ marginLeft: pageOptions.pageWithSidebar ? '320px' : '0px' }" />
        <b-col class="p-4">
          <router-view 
            :user="user"
            :checkRole="checkRole"
          />
        </b-col>
      </b-row>
    </b-container>
    <!--<Footer />-->
  </div>

</template>

<script>
import './assets/css/custom.css'
import { mapState } from 'vuex'
import PageOptions from './config/PageOptions'
import Sidebar from './components/sidebar/Sidebar'
import Header from './components/Header'
//import Footer from './components/Footer'

export default {
  name: 'App',
  components: {
    Sidebar,
    Header,
    //Footer
  },
  data() {
		return {
      pageOptions: PageOptions
		}
  },
  computed: {
		...mapState('auth', ['user']),
  },
	methods: {
    checkRole(user, requiredRole) {
      if (user && user.role.name === requiredRole) {
        return true;
      } else {
        return false;
      }
    }
	},
  mounted () {
  },
	created() {
  }
}
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Open+Sans:wght@400;700&display=swap');
#app {
}
</style>
